export const CONFIG_TOOL_NAME = 'Config'
